import get from "lodash-es/get";
import {
  VERSIONS_XML_NEO,
  VERSIONS_XML_PMAX,
} from "constants/versionsXMLTypes";

import { PMAX_XMLS, NEO_XMLS } from "constants/FileNames";
import { SHOW_XMLs_PERMISSION } from "constants/permissions";
import {
  _getEmailTemplatesInfo,
  _getEventsInfo,
  _getIQConfigInfo,
  _getIQPatchTags,
} from "./commonMappers.map";

export const readVersionsMapper = (data) => {
  const versions = data.essentials.versions.edges.map(({ node }) => ({
    id: node.id_version,
    version: node.version,
    description: node.description,
  }));
  return [versions, data.essentials.pageInfo];
};

export const readVersionFilesMapper = (data) => {
  const id = get(data, "essentials.versions.edges.0.node.id_version");
  const iqConfig = get(data, "essentials.versions.edges.0.node.iq_config", []);
  const iqPatchTags = get(
    data,
    "essentials.versions.edges.0.node.iq_patch_tags",
    [],
  );
  const emailTemplates = get(
    data,
    "essentials.versions.edges.0.node.email_templates",
    [],
  );
  const events = get(data, "essentials.versions.edges.0.node.events", []);
  const xmls = get(data, "essentials.versions.edges.0.node.assigned_xmls", []);
  const is_assigned = get(data, "essentials.versions.edges.0.node.is_assigned");
  return [
    _getXmlInfo(PMAX_XMLS, VERSIONS_XML_PMAX, xmls, id, is_assigned.pmax),
    _getXmlInfo(NEO_XMLS, VERSIONS_XML_NEO, xmls, id, is_assigned.neo),
    _getIQConfigInfo(iqConfig),
    _getIQPatchTags(iqPatchTags),
    _getEmailTemplatesInfo(emailTemplates),
    _getEventsInfo(events, "id_event"),
  ];
};

const _getXmlInfo = (name, xmlType, xmls, versionId, hasFile) => ({
  name,
  xmlType,
  versionId,
  hasFile: hasFile,
  assignedXmls: xmls.map((xml) => xml.id_xml),
  permission: SHOW_XMLs_PERMISSION,
});

export const readVersionLanguagesMapper = (data) => {
  const locales = get(data, "essentials.versions.edges.0.node.locales", []);
  return _getLocales(locales);
};

const _getLocales = (data) => {
  return data.map((locale) => ({
    id: locale.id_locale,
    name: locale.locale,
    info: _getLocationFiles(locale.locale_files),
    hasFile: !!get(locale, "locale_files", []).length,
  }));
};

const _getLocationFiles = (data) => {
  return data.map((file) => ({ name: file.filename, id: file.id_file }));
};

export const readVersionsXmlsMapper = (data) => {
  const xmls = get(data, "essentials.xmls.edges", []).map(({ node }) => ({
    id: node.id_xml,
    filename: node.filename,
  }));
  return [xmls, data.essentials.xmls.pageInfo];
};
